import { Stack } from '@mui/material';

import { FilterEditSelect } from './components/FilterEditSelect/FilterEditSelect';
import { FilterList } from './components/FilterList/FilterList';
import { FilterSharePopover } from './components/FilterSharePopover/FilterSharePopover';
import { useFilterSharePopover } from './components/FilterSharePopover/FilterSharePopover.hooks';
import { FilterCategory, Filter, FiltersPropsShared } from './Filters.types';

const defaultCategories: FilterCategory[] = [FilterCategory.PERSONAL, FilterCategory.DEFAULT];

export interface FilterEditProps extends FiltersPropsShared {
  categories?: FilterCategory[];
  onFilterSelect: (filter: Filter) => void;
}

export const Filters = ({
  categories = defaultCategories,
  filters,
  favoriteFilters,
  favoriteFiltersMaxReached,
  selected,
  onFilterSelect,
  onFilterDelete,
  onFilterToggleFavorites,
}: FilterEditProps) => {
  const { onFilterShare, ...sharePopoverProps } = useFilterSharePopover();
  return (
    <Stack
      spacing={2}
      direction="row"
      sx={{
        overflow: 'hidden',
        alignItems: 'center',
      }}
    >
      <FilterList selected={selected} items={favoriteFilters} onFilterSelect={onFilterSelect} />
      <FilterEditSelect
        color="default"
        items={filters}
        favoriteFiltersMaxReached={favoriteFiltersMaxReached}
        categories={categories}
        selected={selected}
        onItemClick={onFilterSelect}
        onItemDelete={onFilterDelete}
        onItemShare={onFilterShare}
        onItemToggleFavorites={onFilterToggleFavorites}
        disabled={!filters.length}
      />
      <FilterSharePopover {...sharePopoverProps} />
    </Stack>
  );
};
